import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class DeliveriesTableCtrl implements IController {
  infiniteScroll: any;
  columns: any;
  selectedServices: any;
  isScrollable: any;
  selectedServicesChanged: Function;

  private selectedKeys: any;
  private hasFleetManagementPermission: any;
  private hasPricePlanPermission: any;
  private displayAsItems: any;

  public isSortLocationPickup: boolean = false;

  /* @ngInject */
  constructor(private $mdMedia, private commonsConstants, private deliveriesConstants, private IAMPermissions) {
    this.hasFleetManagementPermission = this.IAMPermissions.hasPermission('fleetManagement.vehicles.list');
    this.hasPricePlanPermission = this.IAMPermissions.hasPermission('priceplan.list');
  }

  $onInit() {
    this.selectedKeys = {};

    this.selectedKeys = {};
    _.forEach(this.selectedServices, (s) => {
      this.selectedKeys[s.id] = true;
    });

  }

  $onChanges(changes) {
    if (changes.selectedServices && !changes.selectedServices.isFirstChange()) {
      this.$onInit();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  toggleDelivery(service) {
    const selectedServicesCopy = angular.copy(this.selectedServices)
    const serviceIndex = _.findIndex(this.selectedServices, (s: any) => {
      return s.id === service.id;
    })

    if (serviceIndex > -1) {
      selectedServicesCopy.splice(serviceIndex, 1);
    } else {
      selectedServicesCopy.push(service);
    }

    this.selectedServicesChanged({services: selectedServicesCopy});
  }

  onDragStart(event, draggedService) {
    const services = this.selectedServices?.length ? this.selectedServices : [draggedService];
    const items = services.map((s) => {
      return {
        content: 'Service',
        id: s.id,
        data: s,
        // jobType: job.jobType,
        // skills: job.skills,
      }
    });

    // const items = [{
    //   content: 'Service',
    //   id: draggedService.id,
    //   service: draggedService,
    //   // jobType: job.jobType,
    //   // skills: job.skills,
    // }]

    event.originalEvent.dataTransfer.setData('text', JSON.stringify({
      content: 'LeftOvers',
      items: items
    }));
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesDragTable', {
    bindings: {
      infiniteScroll: '<',
      columns: '<?',
      selectedServices: '<',
      isScrollable: '<?',
      selectedServicesChanged: '&'
    },
    template: require('./deliveries-drag-table.html').default,
    controller: DeliveriesTableCtrl
  });
